module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAJklEQVQ4y2NgGAUjEvxv+I8OGkjT0kCaLQ2kOayBNL80jMbosAIAUVw2z3xczugAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/arrow-dropdown.png
// module id = 444
// module chunks = 0